<template>
    <div class='row md-mb-5'>
        <div class='col-lg-5 col-12' id='MyActives'>
            <div class='o-text-primary u-font-weight-600 mb-2'>Мои активы</div>
            <div class='mb-4 asset-grid'>
                <CryptoElementComponent v-for="crypto in cryptos"
                  :crypto="crypto"
                  @buy="buy"
                  @sale="sale"
                  @concl="concl"
                  @deposit="deposit"
                  @cash="cash"
                  @new_card="newCard"
                  @new_wallet="newWallet"
                  @showVerification="showModal"
                  :cards="cards"
                  :wallets="wallets"
                  :key="crypto.id"
                  :balances="balances"
                  :user="user"
                  :courses="crypto.currency?.code == 'USDT' ? '1' : courses_BTC2USDT_rate"
                  :courses_list="courses"
                  :for_buy="for_buy"
                  :for_deposit="for_deposit"
                  :bank_list="bank_list"
                  :currencies="currencies"
                  :myMethods="myMethods"
                />
            </div>
            <BannerDesktop/>
        </div>

         <div class='col-lg-7 col-md-12 col-12'>
            <div class='row'>
                <VerificationBoard @showModal="showModal" :user="user"/>
            </div>
          
            <cards-component
                @close="closeCard"
                :cards="cards"
                :cards_count="cards_count"
                :flag="newCardFlag"
                :bank_list="bank_list"
            ></cards-component>
            <wallets-component
                @delete="delete_wallet"
                @close="closeWallet"
                :crypto="cryptos"
                :wallets="wallets"
                :wallets_count="wallets_count"
                :flag="newWalletFlag"
            ></wallets-component>
            <BannerMobile/>
        </div> 
        <verification v-show='isModalVisible' @close='closeModal' @verify='verify' :user="user"></verification>
        
        <buy-crypto v-if="isBuyVisible" 
            ref="buyCrypto"
            @close="closeBuy"
            :crypto="selectedCrypto"
            :courses="courses"
            :myMethods="myMethods"
            :user="user"
        />
        
        <sale-crypto v-if="isSaleVisible"
            ref="saleCrypto"
            @close="closeSale"
            :crypto="selectedCrypto"
            :courses="courses"
            :myMethods="myMethods"
            :user="user"
            :cards="cards"
            :balances="balances"
            :currencies="currencies"
        />
    </div>
</template>
<script>
    import CryptoElementComponent from "./CryptoElementComponent.vue";
    import Verification from "./Verification.vue";
    import VerificationBoard from "./VerificationBoard.vue";
    import ConversionComponent from "./ConversionComponent.vue";
    import AppSpinner from "../General/AppSpinner.vue";
    import BannerDesktop from "./BannerDesktop.vue";
    import BannerMobile from "./BannerMobile.vue";
    import BuyCrypto from "./BuyCrypto.vue";
    import SaleCrypto from "./SaleCrypto.vue";
    import Vue from "vue";
    import NewCheck from "./NewCheck.vue";
    import Pagination2 from 'vue-pagination-2';
    import moment from "moment";
    Vue.component('cards-component', require('../Cards/CardsComponent.vue').default);
    Vue.component('wallets-component', require('../Wallets/WalletsComponent.vue').default);

    export default {
        props: [
            'courses',
            'user',
            'cards',
            'wallets',
            'cards_count',
            'wallets_count',
            'user_load',
            'cryptos',
            'balances',
            'checks',
            'for_buy',
            'for_deposit',
            'bank_list',
            'currencies'
        ],
        components: {
            NewCheck,
            CryptoElementComponent,
            BannerMobile,
            BannerDesktop,
            VerificationBoard,
            ConversionComponent,
            Verification,
            AppSpinner,
            Pagination2,
            BuyCrypto,
            SaleCrypto,
        },
        data: () => ({
                isModalVisible: false,
                isNewCheckVisible: false,
                usdtAmount:0,
                btcAmount:0,
                loadTether: false,
                loadBitcoin: false,
                loadEthereum: false,
                loadToncoin: false,
                loadBinancecoin: false,
                loadLitecoin: false,
                checkTypeShow: 'Единоразовый',
                newCardFlag: false,
                newWalletFlag: false,
                check: '',
                page: 1,  // Начальная страница
                perPage: window.innerWidth > 992 ? 10 : 3,
                moment: moment,
                methods: [],
                isBuyVisible: false,
                isSaleVisible: false,
                selectedCrypto: null,
        }),
        watch: {
            checkTypeShow(newVal, oldVal) {
              if (newVal !== oldVal) {
                this.page = 1; // Сброс текущей страницы
                this.clickCallback(this.page); // Обновление списка элементов
              }
            },
        },
        computed: {
            totalOneChecksCount() {
                    return Object.values(this.checks['one']) ? Object.values(this.checks['one']).reverse().length : 0;
                },
            totalLotChecksCount() {
                    return Object.values(this.checks['lot']) ? Object.values(this.checks['lot']).reverse().length : 0;
                },
            totalChecksCount() {
                    return this.checkTypeShow == 'Единоразовый' ? this.totalOneChecksCount : this.totalLotChecksCount;
                },
            totalPages() {
                    return Math.ceil(this.totalChecksCount / this.perPage);
            },     
            checksList: function() {
                const checksArray = this.checkTypeShow === 'Единоразовый'
                ? Object.values(this.checks['one'])
                : Object.values(this.checks['lot']);
                const start = (this.page - 1) * this.perPage;
                const end = start + this.perPage;
                let arrayCheks = checksArray.slice(start, end);
                if(typeof(this.check) != "undefined" && this.check !== null) {
                    let chekk = arrayCheks.find(c => c.id == this.check.id);
                    if(chekk !== undefined) {
                        this.check = chekk;
                    }
                }
                return arrayCheks;
            },
            courses_BTC2USDT_rate() {
                return this.courses.find(c => (c.pair == 'BTC-USDT'))?.rate ?? 0;
            },
        },
        methods: {
            changeCheckTypeShow() {
              if(this.checkTypeShow == 'Единоразовый') {
                  this.checkTypeShow = 'Многоразовый';
              }  else {
                  this.checkTypeShow = 'Единоразовый';
              }
              this.$forceUpdate();
            },
            convert(data){
                this.$emit('convert');
            },
            newCard() {
                this.newCardFlag = true;
            },
            closeCard(){
              this.newCardFlag = false;
            },
            closeWallet(){
                this.newWalletFlag = false;
            },
            newWallet() {
                this.newWalletFlag = true;
            },
            clickCallback(page)  {
                this.page = page
                            },
            buy(data) {
                this.$emit('buy', data);
            },
            sale(data) {
                this.$emit('sale', data);
            },
            concl(data) {
                this.$emit('concl', data);
            },
            deposit() {
                this.$emit('deposit');
            },
            cash() {
                this.$emit('cash');
            },
            newCheck(data){
                this.check = data;
                this.$emit('check');
            },
            verify(){
                this.$emit('verify');
            },
            showModal() {
                if(this.$metrika !== undefined) {
                    this.$metrika.reachGoal('pop_up_verification');
                }
                this.isModalVisible = true;
                document.body.style.overflow = 'hidden';
            },
            closeModal() {
                this.isModalVisible = false;
                document.body.style.overflow = 'auto';
            },
            showCheck(id) {
                
                this.check = this.checksList.find(check => check.id == id)

                if(this.$metrika !== undefined) {
                    this.$metrika.reachGoal('invoice_pop_up');
                }
                this.isNewCheckVisible = true;
                var modalElement = document.getElementById('newCheckModal');
                if (modalElement) {
                    var myModal = new bootstrap.Modal(modalElement);
                    myModal.show();
                }
            },
            showNewCheck() {
                this.isNewCheckVisible = true;
                this.check = '';
            },
            closeNewCheck() {
                this.isNewCheckVisible = false;
                this.check = '';
            },
            delete_wallet(data) {
                this.$emit('del_wallet', data)
            },
            showBuy(crypto, amount = null) {
                this.selectedCrypto = crypto;
                this.isBuyVisible = true;
                if (amount) {
                    // Emit event to BuyCrypto component to set amount
                    this.$nextTick(() => {
                        this.$refs.buyCrypto?.setAmount(amount);
                    });
                }
            },
            showSale(crypto, amount = null) {
                console.log('showSale called with:', { crypto, amount });
                this.selectedCrypto = crypto;
                this.isSaleVisible = true;
                if (amount) {
                    // Emit event to SaleCrypto component to set amount
                    this.$nextTick(() => {
                        console.log('Setting amount in SaleCrypto:', amount);
                        this.$refs.saleCrypto?.setAmount(amount);
                    });
                }
            },
            closeBuy() {
                this.isBuyVisible = false;
                this.selectedCrypto = null;
            },
            closeSale() {
                this.isSaleVisible = false;
                this.selectedCrypto = null;
            },
        },
        created() {
            console.log('ActivesComponent created');
            // Handle GET parameters
            const { action, amount, currency } = this.$route.query;
            console.log('GET params:', { action, amount, currency });
            console.log('Available cryptos:', this.cryptos);
            
            if (action && amount && currency) {
                // Find the crypto by currency code
                const crypto = this.cryptos.find(c => c.currency?.code === currency);
                console.log('Found crypto:', crypto);
                
                if (crypto) {
                    this.selectedCrypto = crypto;
                    if (action === 'buy') {
                        this.showBuy(crypto, amount);
                    } else if (action === 'sell') {
                        this.showSale(crypto, amount);
                    }
                }
            }
            this.fetchMethods();
        },
    }
</script>

<style scoped>
    .lk__list p {
        font-size: 12px;
        font-family: Montserrat;
        Line-height: 17px;
    }
    .lk__list span {
        font-size: 15px;
    }

    .f14, .f14 span {
        font-size: 14px;
    }

    .f15, .f15 span {
        font-size: 15px;
    }
    .f17 .f17 span {
        font-size: 17px;
    }
    .ver_btn {
        height: 40px;
        font-size: 16px;
    }
    .user_block span{
        display: block;
    }

    .no_min_height {
        min-height: unset !important;
    }
</style>
